var exports = {
  "iE": "x936d19a0--a43d94--wrapper",
  "kL": "x936d19a0--a43d94--container",
  "DD": "x936d19a0--a43d94--title",
  "Qq": "x936d19a0--a43d94--text",
  "h_": "x936d19a0--a43d94--description",
  "qr": "x936d19a0--a43d94--footer",
  "kR": "x936d19a0--a43d94--cards",
  "wx": "x936d19a0--a43d94--header",
};

module.exports = exports;
